export const loginSiteUrl: string = import.meta.env.VITE_LOGIN_SITE_URL
  ? import.meta.env.VITE_LOGIN_SITE_URL
  : ''

  export const legacyLoginSiteUrl: string = import.meta.env.VITE_LEGACY_LOGIN_SITE_URL
  ? import.meta.env.VITE_LEGACY_LOGIN_SITE_URL
  : ''

export const logoutSiteUrl: string = import.meta.env.VITE_LOGOUT_URL
  ? import.meta.env.VITE_LOGOUT_URL
  : ''
